<template>
    <main class="bucket-list-wrapper sorted-filtered-list">
        <div class="list-banner">
            <div class="overlay"></div>
            <h1 class="banner-title">Bucket Lists</h1>
        </div>
        <LoadingScreen v-if="!loaded" message="Loading your bucket lists…" />
        <div v-else-if="!isEmpty || hasQuery" class="max-width-container">
            <div class="action-bar">
                <router-link to="/bucket-lists/add">
                    <Bttn class="add-bucket-list" icon="add_circle">
                        Add bucket list
                    </Bttn>
                </router-link>
                <ListActions :current="actionsEdit" @update="setAction" />
            </div>
            <div
                :class="[
                    'sort-filter-bar',
                    { 'with-margin': loaded && actionsEdit },
                ]"
            >
                <FilteringWidget
                    v-if="loaded"
                    :editing="actionsEdit"
                    :filters="filters"
                    :query="store.query"
                    @update="updateList"
                />
                <SortingWidget
                    v-if="loaded"
                    :editing="actionsEdit"
                    :columns="sortColumns"
                    :query="store.query"
                    @update="updateList"
                />
            </div>
            <div v-if="loaded" id="bucket-lists-list">
                <ul>
                    <BLCardItem
                        v-for="bl in list"
                        :key="bl.id"
                        :bucket-list="bl"
                    />
                </ul>
            </div>
        </div>
        <div v-else class="max-width-container empty">
            <router-link to="/bucket-lists/add">
                <Bttn class="add-bucket-list" icon="add_circle">
                    Add bucket list
                </Bttn>
            </router-link>
        </div>
    </main>
</template>

<script>
import { useBucketListStore } from "js/stores/bucketListStore";
import BLCardItem from "js/components/list-items/BLCardItem";
import ListActions from "js/components/widgets/ListActions";
import LoadingScreen from "js/components/common/LoadingScreen";
import SortedFilteredListPage from "js/base/SortedFilteredListPage";

export default {
    name: "BucketListList",
    components: {
        BLCardItem,
        LoadingScreen,
        ListActions,
    },
    extends: SortedFilteredListPage,
    data() {
        return {
            loaded: false,
            sortColumns: [
                ["created_at", "Created"],
                ["name", "Name"],
                ["type", "Type"],
            ],
            filters: [
                ["type", "Type", this.$enumOptions("bucket_list_type")],
                [
                    "bucket_list_items-geo_country",
                    "Country",
                    this.$enumOptions("country"),
                ],
            ],
        };
    },
    async mounted() {
        this.store = useBucketListStore();
        this.list = this.store.dirty ? await this.getList() : this.store.list;
        this.loaded = true;
    },
    methods: {
        async getList() {
            const bucketLists = await this.store.fetch(
                "/api/bucket-lists/?with-items",
                this.store.query
            );
            this.store.populate(bucketLists);
            return this.store.list;
        },
    },
};
</script>
